import tokenManager from "../auth/TokenManager";

class HttpInterceptor {
    constructor() {
        this.originalFetch = null;
        this.isInitialized = false;
        this.apiDomainProd = process.env.API_DOMAIN_PROD;
        this.apiDomainTest = process.env.API_DOMAIN_TEST;
    }

    init() {
        if (this.isInitialized) {
            return;
        }

        if (typeof window === "undefined" || !window.fetch) {
            return;
        }

        this.originalFetch = window.fetch;
        this.isInitialized = true;

        const self = this;
        window.fetch = function (url, options = {}) {
            return self.interceptFetch.call(self, url, options);
        };
    }

    async interceptFetch(url, options) {
        try {
            let modifiedUrl = url;
            const modifiedOptions = { ...options };

            if (this.isApiUrl(url)) {
                modifiedUrl = this.modifyUrlForProxy(url);
                const token = await tokenManager.getToken();
                if (token) {
                    const hdrs = new Headers(options.headers || {});
                    hdrs.set("Authorization", `Bearer ${token}`);
                    modifiedOptions.headers = hdrs;
                }
            }

            return await this.originalFetch.call(
                window,
                modifiedUrl,
                modifiedOptions
            );
        } catch (error) {
            throw error;
        }
    }

    isApiUrl(url) {
        return (
            url.startsWith(this.apiDomainProd) ||
            url.startsWith(this.apiDomainTest)
        );
    }

    modifyUrlForProxy(url) {
        if (url.includes("/web-bff")) return url;

        if (url.startsWith(this.apiDomainProd)) {
            return url.replace(
                this.apiDomainProd,
                this.apiDomainProd + "web-bff/proxy/"
            );
        } else if (url.startsWith(this.apiDomainTest)) {
            return url.replace(
                this.apiDomainTest,
                this.apiDomainTest + "web-bff/proxy/"
            );
        }

        return url;
    }

    destroy() {
        if (this.isInitialized && this.originalFetch) {
            window.fetch = this.originalFetch;
            this.originalFetch = null;
            this.isInitialized = false;
        }
    }
}

const httpInterceptor = new HttpInterceptor();

export default httpInterceptor;
